/* Moved from snippets/product-media-gallery.liquid so browsers cache it (speed audit item 6, 16 Oct 2026); loaded async where the
   inline script was. */
    (function () {
      if (window.hlthStatCounterInit) return;
      window.hlthStatCounterInit = true;

      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var DURATION = 1400;

      function getTextNode(el) {
        for (var i = 0; i < el.childNodes.length; i++) {
          if (el.childNodes[i].nodeType === 3) return el.childNodes[i];
        }
        // Create a text node before the unit span if none exists
        var tn = document.createTextNode('');
        el.insertBefore(tn, el.firstChild);
        return tn;
      }

      function animate(el) {
        var target = parseFloat(el.getAttribute('data-hlth-gallery-count'));
        if (isNaN(target)) return;
        var textNode = getTextNode(el);
        if (reduceMotion) { textNode.textContent = String(target); return; }

        var start = null;
        textNode.textContent = '0';
        function step(ts) {
          if (!start) start = ts;
          var progress = Math.min((ts - start) / DURATION, 1);
          var eased = 1 - Math.pow(1 - progress, 3);
          textNode.textContent = String(Math.round(target * eased));
          if (progress < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      }

      /* Count up only a badge that scrolls into view after the page is ready. A badge already
         on screen (or scrolled past) keeps its real number: resetting it to 0 seconds after it
         painted read as a glitch (speed audit, 15 Oct 2026). */
      function triggerAll() {
        if (!('IntersectionObserver' in window)) return;
        var els = Array.prototype.filter.call(
          document.querySelectorAll('.hlth-gallery-stat__value[data-hlth-gallery-count]'),
          function (el) {
            var r = el.getBoundingClientRect();
            return r.height > 0 && r.top >= window.innerHeight;
          }
        );
        if (!els.length) return;
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              io.unobserve(entry.target);
              animate(entry.target);
            }
          });
        }, { threshold: 0.25 });
        els.forEach(function (el) { io.observe(el); });
      }

      if (document.readyState === 'loading') {
        (document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', triggerAll) : triggerAll());
      } else {
        triggerAll();
      }
    })();
  
